export const version = '0.9.8';
//# sourceMappingURL=version.js.map